import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ClassProvider } from './context/ClassContext';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import ScenariosPage from './pages/ScenariosPage';
import ScenarioDetailPage from './pages/ScenarioDetailPage';
import ResourcesPage from './pages/ResourcesPage';
import AboutPage from './pages/AboutPage';

const App = () => {
  return (
    <ClassProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-gray-50">
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/scenarios" element={<ScenariosPage />} />
            <Route path="/scenario/:id" element={<ScenarioDetailPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/about" element={<AboutPage />} />
          </Routes>
          
          <footer className="bg-gray-900 text-white py-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center">
                <p className="text-gray-300">
                  © {new Date().getFullYear()} Formation Michel Cardinal - Tous droits réservés
                </p>
              </div>
            </div>
          </footer>
        </div>
      </BrowserRouter>
    </ClassProvider>
  );
};

export default App;